import React from 'react';
import IconSmile from '@/assets/IconSmile.svg';

import { THeaderInformationProps } from './types';

export function HeaderInformation({
  prefix,
  has_icon,
  suffix,
}: THeaderInformationProps) {
  return (
    <>
      <span
        className="vitrine-template2__header--content-title1"
        data-testid="prefix"
      >
        {prefix}
      </span>
      {has_icon && (
        <span
          className="vitrine-template2__header--content-icon"
          data-testid="icon"
        >
          <img src={IconSmile} alt="Smile" />
        </span>
      )}
      <span className="vitrine-template2__header--content-title2">
        <strong data-testid="suffix">{suffix}</strong>
      </span>
    </>
  );
}
